export default __webpack_public_path__ + "static/media/ManPower.55e0b445.PNG";